import React from 'react'
import Blog from '../Blog';

const Home = () => {

    return (

        <>

            <Blog />
        
        </>

    )

}

export default Home;